import React, { useState } from 'react'
import { connect } from 'react-redux'
import { AddFriend, VideoCamera, Chat, RemoveFriend, Flag } from 'assets/icons/components'
import { loadLocalMedia, checkMediaPermission } from 'ultils'
import {
  REQUEST_CALL_EVENT,
  REFRESH_FRIENDS,
  REFRESH_HISTORY
} from 'constants/realtimeEvent'
import { FriendServices, RealtimeServices, UserSettingsServices } from 'services'

import { toast } from 'components/common/Toast'
import { formatAvatarURL } from 'ultils'
import { Modal, Form, Button, Spinner } from 'react-bootstrap'
import { setConversations } from 'actions/chat'
import { useTranslation } from 'react-i18next'
import i18n from 'config/i18n'
import { Avatar } from 'components/common'


const History = (props) => {
  const { t } = useTranslation('live', { i18n })
  const { user, dispatch, socket, isOnCall, localStream, conversations } = props
  const [blockReason, setBlockReason] = useState('')
  const [isShowBlockModal, setIsShowBlockModal] = useState(false)
  const [askUser, setAskUser] = useState('')
  const [isLoading, setIsLoading] = useState(false)
  const [loaders, setLoaders] = useState([])
  const [loading, setLoading] = useState(null)


  return (
    <div className='content__history'>
    </div>
  )
}

const mapStateToProps = (state) => ({
  user: state.connectionReducer.user,
  socket: state.connectionReducer.socket,
  isOnCall: state.videoCallReducer.isOnCall,
  localStream: state.videoCallReducer.localStream,
  conversations: state.chatReducer.conversations,
})

export default connect(mapStateToProps)(History)
